import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { IconButton, Badge, Divider, Button, useMediaQuery } from '@mui/material'
import { Collapse, Nav, Row, Col } from 'react-bootstrap'
import TextEllipsis from './TextEllipsis'


/** CONSTANTS */
import { scale } from '../../constants/scale'
import { colors } from '../../constants/colors'

/** STYLES */
import { styled } from '@mui/material/styles'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUpRounded'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded'
import './Style.css'
import { menuFirsts, menuSeconds, menuThirds } from '../../constants/menu'
import { useTranslation } from 'react-i18next'
import { matchRoute } from '../../utils/activeRouter'
import _ from 'lodash'
import { getBranch, getPermissionActiveMenu, getPermissionMenus, getPermissions } from '../../utils/app.utils'
import { STORAGE_KEY } from '../../utils/enum'

import { getProfile } from '../../utils/app.utils'
import LeaseAgreementApi from '../../api/stall/leaseAgreement/leaseAgreement.api'
import { decode, encode } from 'js-base64';
import NotificationApi, { MenuBadgeCount, MenuBadgeResponse } from '../../api/notification/notification.api'
/** ใช้เฉพาะ loadLegacyBadge — ลบพร้อมกันได้เมื่อ backend ใหม่ขึ้นครบทุก environment */
import BidderApi from '../../api/stall/bidder/bidder.api'
import RepairApi from '../../api/repair/repair.api'
import CancelContractApi from '../../api/stall/cancelcontract/cancelcontract'
import TranferApi from '../../api/transfer-lease-agreement/transfer-lease-agreement'
import InvoiceApi from '../../api/invoid/invoid.api'
import CertificateAPI from '../../api/stall/certificate/certificate'
import DepositApi from '../../api/stall/deposit/deposit.api'

const MenuFirstLevel = styled('div')(({ theme }) => ({
   width: '100%',
   top: scale.navbarHeight,
   zIndex: 1200,
   overflow: 'hidden',
   [theme.breakpoints.up('md')]: {
      maxWidth: `calc(${scale.sidebarSize} - 3px)`
   },
   [theme.breakpoints.up('xl')]: {
      maxWidth: scale.sidebarSize
   },
   // [theme.breakpoints.down('xl')]: {
   //    top: `calc(${scale.navbarHeight} - 1rem)`
   // },
   [theme.breakpoints.down('md')]: {
      top: `calc(${scale.navbarHeight} - 1.5rem)`,
      maxWidth: 0,
      '& .menu-first-level .flex-name': {
         paddingLeft: '.5rem !important',
         paddingRight: '.5rem !important'
      },
      '& .menu-first-level .flex-name .menu-first-text': {
         paddingLeft: '.5rem !important'
      },
      '& .menu-first-level .flex-name .menu-first-icon::before': {
         background: 'transparent'
      }
   },
   [theme.breakpoints.down('sm')]: {
      top: `calc(${scale.navbarHeight} - 2.5rem)`,
   },
   '&.show': {
      maxWidth: '45%',
      overflow: 'unset !important',
      [theme.breakpoints.up('sm')]: {
         maxWidth: '30%'
      },
      [theme.breakpoints.up('md')]: {
         maxWidth: '248px'
      }
   },
   '& .menu-first-level .flex-name svg': {
      width: 24,
      height: 24,
      [theme.breakpoints.up('lg')]: {
         width: 27,
         height: 27
      },
      [theme.breakpoints.up('xl')]: {
         width: 30,
         height: 30
      }
   }
}))
const MenuSecondLevel = styled('div')(({ theme }) => ({
   '&.active': {
      width: '100%',
      height: '100%',
      maxWidth: '248px',
      [theme.breakpoints.down('lg')]: {
         '.menu-second-level .item-second-list': {
            padding: '0.406rem 0.5rem !important'
         }
      }
   },
   // '&.active12': {
   //    width: '100%',
   //    maxWidth: '248px',
   //    top: `calc(calc(${scale.navbarHeight} + ${scale.secondToggleStore}))`,
   //    [theme.breakpoints.down('lg')]: {
   //       '.menu-second-level .item-second-list': {
   //          padding: '0.406rem 0.5rem !important',
   //       }
   //    },
   //    [theme.breakpoints.up('lg')]: {
   //       '.menu-second-level .item-second-list': {
   //          padding: '0.406rem 0.5rem !important',
   //       }
   //    },
   // },
   // '&.active13': {
   //    width: '100%',
   //    maxWidth: '248px',
   //    top: `calc(calc(${scale.navbarHeight} + ${scale.secondToggle}))`,
   //    [theme.breakpoints.down('lg')]: {
   //       '.menu-second-level .item-second-list': {
   //          padding: '0.406rem 0.5rem !important'
   //       }
   //    },
   //    [theme.breakpoints.up('lg')]: {

   //       '.menu-second-level .item-second-list': {
   //          padding: '0.406rem 0.5rem !important',
   //       }
   //    },
   // },
   // '.menu-second-level': {
   //    '.item-second-list': {
   //       '&:hover, &[aria-expanded="true"]': {
   //          backgroundColor: colors.themeMainColor,
   //          color: colors.themeSecondColor
   //       }
   //    }
   // },
}))
const MenuScroll = styled('div')(({ theme }) => ({
   maxHeight: `calc(100vh - ${scale.navbarHeight})`,
   [theme.breakpoints.down('xl')]: {
      maxHeight: `calc(100vh - (${scale.navbarHeight} - 1rem))`
   },
   [theme.breakpoints.down('lg')]: {
      maxHeight: `calc(100vh - (${scale.navbarHeight} - 1.5rem))`,
   },
   [theme.breakpoints.down('sm')]: {
      maxHeight: `calc(100vh - (${scale.navbarHeight} - 2.5rem))`
   }
}))
const MenuFirstLevelScroll = styled(MenuScroll)(({ theme }) => ({
   // justifyContent: 'space-between',
   display: 'flex',
   flexDirection: 'column',
   height: '100%',
   [theme.breakpoints.down('lg')]: {
      paddingBottom: '0rem !important'
   }
}))
const SidebarBackdrop = styled('div')(({ theme }) => ({
   display: 'none',
   // [theme.breakpoints.up('lg')]: {
   //    '&.show': {
   //       position: 'fixed',
   //       top: 0,
   //       width: '100%',
   //       height: '100%',
   //       display: 'block',
   //       zIndex: 1199
   //    }
   // }
}))
const CustomBadge = styled(Badge)(({ theme }) => ({
   '.MuiBadge-badge': {
      backgroundColor: colors.themeMainColor,
      fontSize: 9,
      minWidth: 'unset',
      height: 14,
      padding: 0
   }
}))

const MenuThirdLevel = styled('div')(({ theme }) => ({
   '.menu-third-level': {
      '.item-third-list': {
         '&:hover': {
            backgroundColor: colors.green_06,
            color: colors.themeMainColor
         }
      }
   }
}))

const NotiForAdmin = styled('div')(({ theme }) => ({
   width: 30,
   height: 30,
   backgroundColor: colors.danger,
   borderRadius: 50,
   // zIndex: -1,
   position: 'absolute',
   left: 15,
   bottom: 12,
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
   border: `2px solid ${colors.white}`,
   color: colors.white,
   fontSize: 12
}))

type SidebarProps = {
   /** สิทธิ์ของเมนูที่ตรงกับ route ปัจจุบัน ส่งมาจาก AppShell
    *  รับเป็น prop เพื่อไม่ต้องลุ้นว่า effect ของ Sidebar จะทำงานก่อนหรือหลัง AppShell เขียน localStorage */
   activeMenu?: any
   /** ปุ่ม hamburger บนจอเล็กสั่งเปิดเมนูผ่านตรงนี้ — เดิมไปเติม class ใส่ DOM เองซึ่งชนกับ className ที่ React คุมอยู่ */
   mobileOpen?: boolean
}

export default function Sidebar({ activeMenu: activeMenuProp, mobileOpen }: SidebarProps = {}) {
   const { t } = useTranslation();
   const history = useHistory()
   const { pathname } = useLocation()
   const matches = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));
   const branchId: any = getBranch() ? Number(getBranch()) : undefined

   const [hover, setHover]: any[] = useState(false)
   const [toggleLevel2, setToggleLevel2] = useState(0)
   const [toggleLevel3, setToggleLevel3]: any[] = useState([])
   const [activeMenuLevel1, setActiveMenuLevel1] = useState<any>('');
   /** ตัวเลข badge ทุกเมนูมาจาก GET /notification/menu-badge เส้นเดียว (backend นับด้วย COUNT ไม่มีเพดาน 100 แบบเดิม) */
   const [menuBadge, setMenuBadge] = useState<MenuBadgeResponse>({})
   /** ผู้เช่ามีสัญญาแล้วหรือยัง -> เลือกชุดเมนู คงค่าเดิมไว้ถ้า request ล้ม ไม่ให้เมนูสลับชุดเพราะ error ชั่วคราว */
   const [hasLeaseAgreement, setHasLeaseAgreement] = useState<boolean>(false)
   const adminBadge = menuBadge.role === 'ADMIN' ? menuBadge : undefined
   const tenantBadge = menuBadge.role === 'TENANT' ? menuBadge : undefined
   const notiTotal = adminBadge?.bidder_preliminary.count ?? 0
   const notiTotalRepair = adminBadge?.repair.count ?? 0
   const notiTotalCancel = adminBadge?.cancel_contract.count ?? 0
   const notiTotalTransfer = adminBadge?.transfer.count ?? 0
   const notiTotalCertificate = adminBadge?.certificate.count ?? 0
   const notiDepositTotal = tenantBadge?.deposit.count ?? 0
   const notiTotalInvoice = (adminBadge ?? tenantBadge)?.invoice.count ?? 0
   /** จำนวนผู้ถือสิทธิที่มีผู้รับมรดกหมดอายุ -> badge เมนูจัดการข้อมูลลูกค้า (backend รุ่นก่อนก็ส่ง key นี้) */
   const customerHeirCount = (menuBadge.role === undefined ? menuBadge.customer_heir?.count : adminBadge?.customer_heir.count) ?? 0
   const userProfile: any = JSON.parse(getProfile() || '{}')

   /** เดิม decode + parse ก้อนนี้ซ้ำราว 20 ครั้งต่อ render ตอนที่ Sidebar remount ทุกการเปลี่ยนหน้าอยู่แล้ว
    *  ตอนนี้ Sidebar อยู่ยาวและ re-render ทุกครั้งที่ URL เปลี่ยน ต้นทุนนี้เลยมาอยู่บนทางเดินหลักของการเปลี่ยนหน้า */
   const profileData: any = useMemo(() => {
      try {
         return JSON.parse(decode(userProfile))
      } catch {
         return {}
      }
   }, [userProfile])
   const isTenant = profileData?.roleId === 4

   // const menus = getPermissionMenus()
   /** ลิสต์เมนูใน PERMISSION ไม่เปลี่ยนระหว่างเซสชัน (ที่ถูกเขียนทับทุกครั้งที่เปลี่ยนหน้าคือ field activeMenu เท่านั้น)
    *  ต้อง memo ด้วย ไม่งั้น entry นี้เป็น array ใหม่ทุก render แล้ว useMemo ของ menus ข้างล่างก็จะคำนวณใหม่ทุกครั้งอยู่ดี */
   const payBillEntry: any = useMemo(
      () => Object?.entries(getPermissionMenus() || {})?.find(([key, value]: any) => value.menuFirstKey === 'PAY_BILL'),
      []
   );
   const [height, setHeight] = useState(window.innerHeight);

   useEffect(() => {
      const handleResize = () => setHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
   }, []);
   const menus = useMemo(() => isTenant ? getPermissionMenus() : payBillEntry ? {
      ...getPermissionMenus(), [payBillEntry[0]]: {
         menuFirstId: 4,
         menuFirstKey: "PAY_BILL",
         menuFirstSorting: 4,
         menuSeconds: [
            {
               ...payBillEntry[1],
               menuSecondKey: 'PAY_BILL_LIST',
               menuSecondId: 99,
               menuThirds: []
            },
            {
               ...payBillEntry[1],
               menuSecondKey: 'PAY_BILL_INVOICE',
               menuSecondId: 100,
               menuThirds: []
            },
         ]
      }

   } : getPermissionMenus(), [isTenant, payBillEntry])

   const onToggle = (index: string) => {
      setToggleLevel3({ [index]: toggleLevel3[index] === undefined ? true : !toggleLevel3[index] })
   }

   /** กางเมนูชั้น 2 ของหน้าที่กำลังเปิดอยู่
    *  เดิมเรียก onToggle ซึ่งเป็นการสลับค่า ทำได้เพราะรอบนั้น Sidebar เพิ่ง mount ใหม่เสมอ
    *  ตอนนี้ effect นี้ทำงานทุกครั้งที่เปลี่ยนหน้า ถ้ายังสลับค่าอยู่เมนูที่กางไว้จะถูกพับกลับเอง */
   useEffect(() => {
      const activeMenu = activeMenuProp ?? getPermissionActiveMenu()
      if (activeMenu?.menuSecondId) {
         setToggleLevel3({ [`menu-second-${activeMenu.menuSecondId}`]: true })
      }
   }, [activeMenuProp, pathname])

   /** เดิม full reload ปิด flyout ให้เอง */
   useEffect(() => {
      setHover(false)
      setToggleLevel2(0)
   }, [pathname])

   const goToRoute = (route: string, permission: any) => {
      /** ต้องเขียนก่อน push เสมอ ไม่งั้น AppShell จะอ่าน PERMISSION ก้อนเก่าแล้วเขียนทับ */
      const permissions = { ...getPermissions(), activeMenu: permission }
      localStorage.setItem(STORAGE_KEY.PERMISSION, encode(JSON.stringify(permissions)))

      /** เมนูกลุ่ม (STORE / STALL / SETTINGS / ADMIN) มี path เป็น '' — เดิมกลายเป็น href='#' ซึ่งบังเอิญไม่ทำอะไร
       *  แต่ push('#') จะดัน entry ขยะเข้า history stack */
      if (!route) return

      setHover(false)
      setToggleLevel2(0)

      /** กดเมนูของหน้าที่เปิดอยู่: เดิม reload = โหลดข้อมูลใหม่ ตอนนี้ push path เดิมไม่ remount อะไรเลย
       *  จึงไม่ push ซ้ำเพื่อไม่ให้ history stack บวมจนกด Back แล้วเหมือนค้าง */
      if (route === pathname) return

      history.push(route)
   }

   const isToggleLevel1 = (id: number) => {

      if (toggleLevel2 !== id && toggleLevel2 !== 0) {
         setToggleLevel2(id)
      } else if (toggleLevel2 === id) {
         setToggleLevel2(0)
      } else {
         setToggleLevel2(id)

      }
   }

   const hideSidebar = () => {
      setHover(false)
      setToggleLevel2(0)
      setToggleLevel3([])
   }

   /**
    * badge ถูกโหลดใหม่ทุกครั้งที่เปลี่ยนหน้า (เดิมได้มาฟรีเพราะ Sidebar remount ทุกครั้ง)
    * ผู้ใช้กดเมนูรัว ๆ ได้ และ api.tsx เป็น instance เดียวที่ไม่รับ AbortSignal จึงยกเลิก request จริงไม่ได้
    * ใช้ epoch ทิ้งผลลัพธ์ของรอบเก่าที่กลับมาช้ากว่ารอบใหม่แทน
    */
   const badgeEpochRef = useRef(0)
   const isMountedRef = useRef(true)
   useEffect(() => () => { isMountedRef.current = false }, [])
   const isStale = (epoch: number) => !isMountedRef.current || epoch !== badgeEpochRef.current

   /**
    * GET /notification/menu-badge — เดิมยิง list API 6 เส้น (admin) / 4 เส้น (ผู้เช่า) แล้วนับ .length เอง
    * backend อ่าน userId/roleId จาก token เอง ไม่ต้องส่ง userId
    */
   const loadMenuBadge = async (epoch: number) => {
      let payload: MenuBadgeResponse = {}
      try {
         payload = await NotificationApi.menuBadge(branchId)
      } catch {
         /* เส้นใหม่ล้ม -> ตกไปนับแบบเดิมข้างล่าง */
      }
      if (isStale(epoch)) return
      if (!payload.role) payload = await loadLegacyBadge(payload.customer_heir)
      if (isStale(epoch)) return
      setMenuBadge(payload)
      if (payload.role === 'TENANT') setHasLeaseAgreement(payload.has_lease_agreement)
   }

   /**
    * backend รุ่นก่อน (response ไม่มี role มีแค่ customer_heir) — นับจาก list API แบบเดิม แล้วประกอบเป็นรูปเดียวกับเส้นใหม่
    * ติดเพดาน pageLimit เหมือนเดิม ลบทั้งฟังก์ชันได้เมื่อ backend ใหม่ขึ้นครบทุก environment
    */
   const loadLegacyBadge = async (customerHeir?: MenuBadgeCount): Promise<MenuBadgeResponse> => {
      const count = (n: number): MenuBadgeCount => ({ count: n })
      const rows = (req: Promise<any>, pick = (res: any) => res.data): Promise<any[]> =>
         req.then((res) => (res.status === 200 && pick(res)) || []).catch(() => [])
      const countStatus = (list: any[], ...status: string[]) => list.filter((e: any) => status.includes(e.status)).length

      if (isTenant) {
         const condition: any = { page: 1, pageLimit: 100, userId: profileData?.userId, branchId }
         const invoiceCondition: any = { page: 1, pageLimit: 100000, branchId }
         const [deposit, invoice, lease] = await Promise.all([
            rows(DepositApi.findAll(condition)),
            rows(InvoiceApi.findAllNew(invoiceCondition), (res) => res.data.data.items),
            rows(LeaseAgreementApi.findAll({ ...condition, pageLimit: 1 })),
         ])
         return {
            role: 'TENANT',
            deposit: count(countStatus(deposit, 'WAITING')),
            invoice: count(countStatus(invoice, 'WAITING', 'NOT_PAY')),
            has_lease_agreement: lease.length > 0,
         }
      }

      const waiting: any = { page: 1, pageLimit: 100, status: 'WAITING', branchId }
      const bidderCondition: any = { page: 1, pageLimit: 100, branchId }
      const invoiceCondition: any = { page: 1, pageLimit: 100000, status: 'PROGRESS', branchId }
      const [bidder, repair, cancel, transfer, invoice, certificate] = await Promise.all([
         rows(BidderApi.findAllAdmin(bidderCondition)),
         rows(RepairApi.findAll(waiting)),
         rows(CancelContractApi.findAll(waiting)),
         rows(TranferApi.findAll(waiting)),
         rows(InvoiceApi.findAllNew(invoiceCondition), (res) => res.data.data.items),
         rows(CertificateAPI.findAll(waiting)),
      ])
      return {
         role: 'ADMIN',
         customer_heir: customerHeir ?? count(0),
         bidder_preliminary: count(_.sumBy(bidder, (e: any) => Number(e.cnt_preliminary) || 0)),
         repair: count(countStatus(repair, 'WAITING')),
         cancel_contract: count(countStatus(cancel, 'WAITING')),
         transfer: count(countStatus(transfer, 'WAITING')),
         invoice: count(countStatus(invoice, 'PROGRESS')),
         certificate: count(countStatus(certificate, 'WAITING')),
      }
   }

   /** Sidebar อยู่ยาวไม่ remount จึงผูกกับ pathname เองเพื่อให้ตัวเลขแจ้งเตือนสดทุกการเปลี่ยนหน้าเหมือนเดิม */
   useEffect(() => {
      loadMenuBadge(++badgeEpochRef.current)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [pathname, isTenant])

   const activePath = useCallback(() => {
      const preName = pathname.substring(1).split('/')
      if (preName) {
         const name = preName[0]
         setActiveMenuLevel1(matchRoute(name))
      }
   }, [pathname])

   useEffect(() => {
      activePath()
   }, [activePath]);

   return (
      <>
         <MenuFirstLevel
            className={`menu-first ${matches || hover || mobileOpen ? 'show' : ''}`}
            onMouseEnter={() => setHover(true)}
            style={{
               height: height - 80
            }}
            onMouseLeave={() => {
               setHover(false)
               setToggleLevel2(0)
            }}
         >
            <MenuFirstLevelScroll className={'menu-first-wrap'}>
               {menus && !hasLeaseAgreement && isTenant && (
                  _.map(menus, ({ menuFirstId, menuFirstKey, menuSeconds: mSub }: any, iMFrist: number) => {
                     if (menuFirsts[menuFirstKey])
                        // console.log(mSub, 'menuFirstId')
                        return (
                           (menuFirstId === 1 || menuFirstId === 2) && <>
                              {mSub !== undefined && (
                                 (menuFirsts[menuFirstKey] && mSub.length > 0) && (
                                    <>
                                       <Nav.Item
                                          key={`menu-first-${menuFirstId}`}
                                          aria-controls={menuFirstId}
                                          id={menuFirstId}
                                          className={`flex-row menu-first-level  'd-flex') || 'd-none') : 'd-flex'}`}
                                          onClick={() => isToggleLevel1(Number(menuFirstId))}
                                       // onMouseEnter={() => isToggleLevel1(Number(menuFirstId))}

                                       >
                                          <div className={`flex-name menu-first-arrow ${toggleLevel2 === menuFirstId ? 'active' : ''}`}>
                                             <CustomBadge badgeContent={10} max={10} color="error" className="menu-badge" invisible={!menuFirsts[menuFirstKey].badge}>
                                                <IconButton color="primary" component="span" className={`menu-first-icon p-0 ${activeMenuLevel1 === menuFirstKey ? 'active active-level-1' : ''}`}>
                                                   {menuFirsts[menuFirstKey].icon}
                                                </IconButton>
                                                {isTenant && menuFirstId === 2 && notiDepositTotal > 0 && <NotiForAdmin>{notiDepositTotal}</NotiForAdmin>}
                                             </CustomBadge>
                                             <div className="menu-first-text text-ellipsis">
                                                <TextEllipsis title={t(menuFirsts[menuFirstKey].textName)} />
                                                {/* {notiDepositTotal > 0 && menuFirstId === 2 && <NotiForAdmin>{notiDepositTotal}</NotiForAdmin>} */}
                                             </div>

                                          </div>

                                          {menuFirsts[menuFirstKey] && mSub.length && (
                                             <>
                                                <MenuSecondLevel
                                                   className={`menu-second ${toggleLevel2 === menuFirstId ? 'active' : ''} ${menuFirstId === 12 ? 'active12' : menuFirstId === 13 ? 'active13' : ''}`}>
                                                   <MenuScroll className={'menu-second-wrap'}>
                                                      {menuFirsts[menuFirstKey] &&
                                                         mSub &&
                                                         _.map(mSub, ({ menuSecondId, menuSecondKey, menuSecoundTags, menuThirds: mThirds }: any, iMSub: number) => {

                                                            if (menuSeconds[menuSecondKey])
                                                               return (menuSeconds[menuSecondKey] && mThirds.length) && (
                                                                  <Nav.Item key={`menu-second-${menuSecondId}`} id={menuSecondId} className={`menu-second-level ${menuSeconds[menuSecondKey].isHidden ? 'd-none' : ''}`}>
                                                                     <Button
                                                                        className={`item-second-list text-ellipsis w-100`}
                                                                        onClick={() => onToggle(`menu-second-${menuSecondId}`)}
                                                                        aria-controls={`menu-second-${menuSecondId}`}
                                                                        aria-expanded={toggleLevel3[`menu-second-${menuSecondId}`]}
                                                                        endIcon={toggleLevel3[`menu-second-${menuSecondId}`] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}>
                                                                        <TextEllipsis title={t(menuSeconds[menuSecondKey].textName)} ellipsis={menuSecondKey === 'MANAGE_DOCTOR_FEE' || menuSecondKey === 'DEFAULT_PRODUCT'} />
                                                                     </Button>
                                                                     <Collapse in={toggleLevel3[`menu-second-${menuSecondId}`]}>
                                                                        <MenuThirdLevel id={`menu-second-${menuSecondId}`} className="menu-third">
                                                                           <ul className={'menu-third-level'}>
                                                                              {_.map(mThirds, ({ menuThirdId, menuThirdKey, menuThirdTags }: any, iMThirds: number) => {
                                                                                 if (menuThirds[menuThirdKey])
                                                                                    return (
                                                                                       menuThirds[menuThirdKey] && (
                                                                                          <Nav.Item key={`menu-third-${menuThirdId}`} className={`item-third-list ${menuThirdKey === 'CURRENCY' && 'd-none'}`} onClick={() => goToRoute(menuThirds[menuThirdKey].path, mThirds[iMThirds])}>
                                                                                             <li className={'w-100 text-ellipsis'} onClick={() => setToggleLevel3}>
                                                                                                <TextEllipsis
                                                                                                   title={t(menuThirds[`${menuThirdKey}`].textName)} />

                                                                                             </li>
                                                                                          </Nav.Item>
                                                                                       )
                                                                                    )
                                                                              })}
                                                                           </ul>
                                                                        </MenuThirdLevel>
                                                                     </Collapse>
                                                                  </Nav.Item>
                                                               ) || (
                                                                     menuSeconds[menuSecondKey] && (
                                                                        <Nav.Item key={`menu-second-${menuSecondId}`} className={`menu-second-level ${menuSeconds[menuSecondKey].isHidden ? 'd-none' : ''}`} onClick={() => goToRoute(menuSeconds[menuSecondKey].path, mSub[iMSub])}>
                                                                           <div className={'item-second-list text-ellipsis'}>
                                                                              <CustomBadge
                                                                                 badgeContent={10}
                                                                                 max={10}
                                                                                 color="error"
                                                                                 className="menu-badge w-100"
                                                                                 invisible={!menuSeconds[menuSecondKey].badge}
                                                                                 sx={{ '.MuiBadge-badge:not(.MuiBadge-invisible)': { position: 'relative', top: 5, left: 8, right: 0, bottom: 0, transform: 'none' } }}>
                                                                                 <TextEllipsis title={t(menuSeconds[menuSecondKey].textName)} />
                                                                                 {notiDepositTotal > 0 && menuSecondId === 5 && <NotiForAdmin style={{ right: '-7px', left: 'inherit', bottom: 5, position: 'absolute' }}>{notiDepositTotal}</NotiForAdmin>}
                                                                              </CustomBadge>
                                                                           </div>
                                                                        </Nav.Item>
                                                                     )
                                                                  )
                                                         })}
                                                   </MenuScroll>
                                                </MenuSecondLevel>
                                             </>
                                          ) || (
                                                <></>
                                             )}
                                       </Nav.Item>
                                    </>
                                 ) || (
                                    menuFirsts[menuFirstKey] &&
                                    !menuFirsts[menuFirstKey].disabled && (
                                       <Nav.Item
                                          key={`menu-first-${menuFirstId}`}
                                          className={`d-flex flex-row menu-first-level`}
                                          onClick={() => goToRoute(menuFirsts[menuFirstKey].path, menus[iMFrist])}
                                          onMouseEnter={() => isToggleLevel1(Number(0))}>
                                          <div className={'flex-name'}>
                                             <CustomBadge badgeContent={1} max={10} color="error" className="menu-badge" invisible={!menuFirsts[menuFirstKey].badge}>
                                                <IconButton color="primary" component="span" className={`menu-first-icon p-0 ${activeMenuLevel1 === menuFirstKey ? 'active active-level-1' : ''}`}>
                                                   {menuFirsts[menuFirstKey].icon}
                                                </IconButton>
                                             </CustomBadge>
                                             <div className="menu-first-text text-ellipsis">
                                                <TextEllipsis title={t(menuFirsts[menuFirstKey].textName)} />
                                             </div>
                                          </div>
                                       </Nav.Item>
                                    )
                                 )
                              )}
                           </>
                        )
                  })
               )}
               {menus && hasLeaseAgreement && isTenant && (
                  _.map(menus, ({ menuFirstId, menuFirstKey, menuSeconds: mSub }: any, iMFrist: number) => {
                     if (menuFirsts[menuFirstKey])
                        return (
                           menuFirstId && menuFirstKey !== 'SUE' && <>
                              {mSub !== undefined && (
                                 (menuFirsts[menuFirstKey] && menuFirstKey !== 'SUE' && mSub.length > 0) && (
                                    <>
                                       <Nav.Item
                                          key={`menu-first-${menuFirstId}`}
                                          aria-controls={menuFirstId}
                                          id={menuFirstId}
                                          className={`flex-row menu-first-level  'd-flex') || 'd-none') : 'd-flex'}`}
                                          onClick={() => isToggleLevel1(Number(menuFirstId))}
                                       // onMouseEnter={() => isToggleLevel1(Number(menuFirstId))}

                                       >
                                          <div className={`flex-name menu-first-arrow ${toggleLevel2 === menuFirstId ? 'active' : ''}`}>
                                             <CustomBadge badgeContent={10} max={10} color="error" className="menu-badge" invisible={!menuFirsts[menuFirstKey].badge} style={{ position: 'relative' }}>
                                                <IconButton color="primary" component="span" className={`menu-first-icon p-0 ${activeMenuLevel1 === menuFirstKey ? 'active active-level-1' : ''}`}>
                                                   {menuFirsts[menuFirstKey].icon}
                                                </IconButton>
                                                {/* {isTenant && menuFirstId === 2 && notiDepositTotal > 0 && <NotiForAdmin>{notiDepositTotal}</NotiForAdmin>}
                                                <NotiForAdmin>{notiDepositTotal}</NotiForAdmin> */}
                                                {/* {notiDepositTotal > 0 && menuFirstId === 2 && <NotiForAdmin>{notiDepositTotal}</NotiForAdmin>} */}
                                                {isTenant && menuFirstId === 2 && notiDepositTotal > 0 && <NotiForAdmin>{notiDepositTotal}</NotiForAdmin>}


                                             </CustomBadge>
                                             <div className="menu-first-text text-ellipsis">
                                                <TextEllipsis title={t(menuFirsts[menuFirstKey].textName)} />
                                             </div>

                                          </div>

                                          {menuFirsts[menuFirstKey] && mSub.length && (
                                             <>
                                                <MenuSecondLevel
                                                   className={`menu-second ${toggleLevel2 === menuFirstId ? 'active' : ''} ${menuFirstId === 12 ? 'active12' : menuFirstId === 13 ? 'active13' : ''}`}>
                                                   <MenuScroll className={'menu-second-wrap'}>
                                                      {menuFirsts[menuFirstKey] &&
                                                         mSub &&
                                                         _.map(mSub, ({ menuSecondId, menuSecondKey, menuSecoundTags, menuThirds: mThirds }: any, iMSub: number) => {

                                                            if (menuSeconds[menuSecondKey])
                                                               return (menuSeconds[menuSecondKey] && mThirds.length) && (
                                                                  <Nav.Item key={`menu-second-${menuSecondId}`} id={menuSecondId} className={`menu-second-level ${menuSeconds[menuSecondKey].isHidden ? 'd-none' : ''}`}>
                                                                     <Button
                                                                        className={`item-second-list text-ellipsis w-100`}
                                                                        onClick={() => onToggle(`menu-second-${menuSecondId}`)}
                                                                        aria-controls={`menu-second-${menuSecondId}`}
                                                                        aria-expanded={toggleLevel3[`menu-second-${menuSecondId}`]}
                                                                        endIcon={toggleLevel3[`menu-second-${menuSecondId}`] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}>
                                                                        <TextEllipsis title={t(menuSeconds[menuSecondKey].textName)} ellipsis={menuSecondKey === 'MANAGE_DOCTOR_FEE' || menuSecondKey === 'DEFAULT_PRODUCT'} />
                                                                     </Button>
                                                                     <Collapse in={toggleLevel3[`menu-second-${menuSecondId}`]}>
                                                                        <MenuThirdLevel id={`menu-second-${menuSecondId}`} className="menu-third">
                                                                           <ul className={'menu-third-level'}>
                                                                              {_.map(mThirds, ({ menuThirdId, menuThirdKey, menuThirdTags }: any, iMThirds: number) => {
                                                                                 if (menuThirds[menuThirdKey])
                                                                                    return (
                                                                                       menuThirds[menuThirdKey] && (
                                                                                          <Nav.Item key={`menu-third-${menuThirdId}`} className={`item-third-list ${menuThirdKey === 'CURRENCY' && 'd-none'}`} onClick={() => goToRoute(menuThirds[menuThirdKey].path, mThirds[iMThirds])}>
                                                                                             <li className={'w-100 text-ellipsis'} onClick={() => setToggleLevel3}>
                                                                                                <TextEllipsis
                                                                                                   title={t(menuThirds[`${menuThirdKey}`].textName)} />
                                                                                                {/* {notiDepositTotal > 0 && menuSecondId === 5 && <NotiForAdmin style={{ right: '-5px', bottom: '5px', position: 'absolute' }}>{notiDepositTotal}</NotiForAdmin>} */}

                                                                                             </li>
                                                                                          </Nav.Item>
                                                                                       )
                                                                                    )
                                                                              })}
                                                                           </ul>
                                                                        </MenuThirdLevel>
                                                                     </Collapse>
                                                                  </Nav.Item>
                                                               ) || (
                                                                     menuSeconds[menuSecondKey] && (
                                                                        <Nav.Item key={`menu-second-${menuSecondId}`} className={`menu-second-level ${menuSeconds[menuSecondKey].isHidden ? 'd-none' : ''}`} onClick={() => goToRoute(menuSeconds[menuSecondKey].path, mSub[iMSub])}>
                                                                           <div className={'item-second-list text-ellipsis'}>
                                                                              <CustomBadge
                                                                                 badgeContent={10}
                                                                                 max={10}
                                                                                 color="error"
                                                                                 className="menu-badge w-100"
                                                                                 invisible={!menuSeconds[menuSecondKey].badge}
                                                                                 sx={{ '.MuiBadge-badge:not(.MuiBadge-invisible)': { position: 'relative', top: 5, left: 8, right: 0, bottom: 0, transform: 'none' } }}>
                                                                                 <TextEllipsis title={t(menuSeconds[menuSecondKey].textName)} />
                                                                                 {notiDepositTotal > 0 && menuSecondId === 5 && <NotiForAdmin style={{ right: '-7px', left: 'inherit', bottom: 5, position: 'absolute' }}>{notiDepositTotal}</NotiForAdmin>}
                                                                              </CustomBadge>
                                                                           </div>
                                                                        </Nav.Item>
                                                                     )
                                                                  )
                                                         })}
                                                   </MenuScroll>
                                                </MenuSecondLevel>
                                             </>
                                          ) || (
                                                <></>
                                             )}
                                       </Nav.Item>
                                    </>
                                 ) || (
                                    menuFirsts[menuFirstKey] &&
                                    !menuFirsts[menuFirstKey].disabled && (
                                       <Nav.Item
                                          key={`menu-first-${menuFirstId}`}
                                          className={`d-flex flex-row menu-first-level`}
                                          onClick={() => goToRoute(menuFirsts[menuFirstKey].path, menus[iMFrist])}
                                          onMouseEnter={() => isToggleLevel1(Number(0))}>
                                          <div className={'flex-name'}>
                                             <CustomBadge badgeContent={1} max={10} color="error" className="menu-badge" invisible={!menuFirsts[menuFirstKey].badge}>
                                                <IconButton color="primary" component="span" className={`menu-first-icon p-0 ${activeMenuLevel1 === menuFirstKey ? 'active active-level-1' : ''}`}>
                                                   {menuFirsts[menuFirstKey].icon}
                                                </IconButton>
                                                {menuFirstId === 4 && notiTotalInvoice > 0 && <NotiForAdmin>{notiTotalInvoice}</NotiForAdmin>}
                                             </CustomBadge>
                                             <div className="menu-first-text text-ellipsis">
                                                <TextEllipsis title={t(menuFirsts[menuFirstKey].textName)} />
                                             </div>
                                          </div>
                                       </Nav.Item>
                                    )
                                 )
                              )}
                           </>
                        )
                  })
               )}
               {menus && !isTenant && (
                  _.map(menus, ({ menuFirstId, menuFirstKey, menuSeconds: mSub }: any, iMFrist: number) => {
                     if (menuFirsts[menuFirstKey])
                        return (
                           menuFirstId && <>
                              {mSub !== undefined && (
                                 (menuFirsts[menuFirstKey] && mSub.length > 0) && (
                                    <>
                                       <Nav.Item
                                          key={`menu-first-${menuFirstId}`}
                                          aria-controls={menuFirstId}
                                          id={menuFirstId}
                                          className={`flex-row menu-first-level  'd-flex') || 'd-none') : 'd-flex'}`}
                                          onClick={() => isToggleLevel1(Number(menuFirstId))}
                                       // onMouseEnter={() => isToggleLevel1(Number(menuFirstId))}

                                       >
                                          <div className={`flex-name menu-first-arrow ${toggleLevel2 === menuFirstId ? '' : ''}`}>
                                             <CustomBadge badgeContent={10} max={10} color="error" className="menu-badge" invisible={!menuFirsts[menuFirstKey].badge}>
                                                <IconButton color="primary" component="span" className={`menu-first-icon p-0 ${activeMenuLevel1 === menuFirstKey ? 'active active-level-1' : ''}`}>
                                                   {menuFirsts[menuFirstKey].icon}
                                                </IconButton>
                                                {isTenant && menuFirstId === 2 && notiTotal > 0 && <NotiForAdmin>{notiTotal}</NotiForAdmin>}
                                                {!isTenant && customerHeirCount > 0 && _.some(mSub, { menuSecondKey: menuSeconds.CUSTOMER_MANAGEMENT.key }) && <NotiForAdmin>{customerHeirCount}</NotiForAdmin>}
                                             </CustomBadge>
                                             <div className="menu-first-text text-ellipsis">
                                                <TextEllipsis title={t(menuFirsts[menuFirstKey].textName)} />
                                             </div>

                                          </div>

                                          {/* {menuFirsts[menuFirstKey] && mSub.length && (
                                             <>
                                                <MenuSecondLevel
                                                   className={`menu-second ${toggleLevel2 === menuFirstId ? 'active' : ''} ${menuFirstId === 12 ? 'active12' : menuFirstId === 13 ? 'active13' : ''}`}
                                                   >
                                                   <MenuScroll className={'menu-second-wrap'}>
                                                      {menuFirsts[menuFirstKey] &&
                                                         mSub &&
                                                         _.map(mSub, ({ menuSecondId, menuSecondKey, menuSecoundTags, menuThirds: mThirds }: any, iMSub: number) => {
                                                            if (menuSeconds[menuSecondKey])
                                                               return (menuSeconds[menuSecondKey] && mThirds.length) && (
                                                                  <Nav.Item key={`menu-second-${menuSecondId}`} id={menuSecondId} className={`menu-second-level ${menuSeconds[menuSecondKey].isHidden ? 'd-none' : ''}`}>
                                                                     <Button
                                                                        className={`item-second-list text-ellipsis w-100`}
                                                                        // onClick={() => onToggle(`menu-second-${menuSecondId}`)}
                                                                        aria-controls={`menu-second-${menuSecondId}`}
                                                                        aria-expanded={toggleLevel3[`menu-second-${menuSecondId}`]}
                                                                        endIcon={toggleLevel3[`menu-second-${menuSecondId}`] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}>
                                                                        <TextEllipsis title={t(menuSeconds[menuSecondKey].textName)} ellipsis={menuSecondKey === 'MANAGE_DOCTOR_FEE' || menuSecondKey === 'DEFAULT_PRODUCT'} />
                                                                     </Button>
                                                                     <Collapse in={toggleLevel3[`menu-second-${menuSecondId}`]}>
                                                                        <MenuThirdLevel id={`menu-second-${menuSecondId}`} className="menu-third">
                                                                           <ul className={'menu-third-level'}>
                                                                              {_.map(mThirds, ({ menuThirdId, menuThirdKey, menuThirdTags }: any, iMThirds: number) => {
                                                                                 if (menuThirds[menuThirdKey])
                                                                                    return (
                                                                                       menuThirds[menuThirdKey] && (
                                                                                          <Nav.Item key={`menu-third-${menuThirdId}`} className={`item-third-list ${menuThirdKey === 'CURRENCY' && 'd-none'}`} onClick={() => goToRoute(menuThirds[menuThirdKey].path, mThirds[iMThirds])}>
                                                                                             <li className={'w-100 text-ellipsis'} onClick={() => setToggleLevel3}>
                                                                                                <TextEllipsis
                                                                                                   title={t(menuThirds[`${menuThirdKey}`].textName)} />
                                                                                             </li>
                                                                                          </Nav.Item>
                                                                                       )
                                                                                    )
                                                                              })}
                                                                           </ul>
                                                                        </MenuThirdLevel>
                                                                     </Collapse>
                                                                  </Nav.Item>
                                                               ) || (
                                                                     menuSeconds[menuSecondKey] && (
                                                                        <Nav.Item key={`menu-second-${menuSecondId}`} className={`menu-second-level ${menuSeconds[menuSecondKey].isHidden ? 'd-none' : ''}`} onClick={() => goToRoute(menuSeconds[menuSecondKey].path, mSub[iMSub])}>
                                                                           <div className={'item-second-list text-ellipsis'}>
                                                                              <CustomBadge
                                                                                 badgeContent={10}
                                                                                 max={10}
                                                                                 color="error"
                                                                                 className="menu-badge w-100"
                                                                                 invisible={!menuSeconds[menuSecondKey].badge}
                                                                                 sx={{ '.MuiBadge-badge:not(.MuiBadge-invisible)': { position: 'relative', top: 5, left: 8, right: 0, bottom: 0, transform: 'none' } }}>
                                                                                 <TextEllipsis title={t(menuSeconds[menuSecondKey].textName)} />
                                                                                 {!isTenant && menuFirstId === 11 && notiTotalCancel > 0 && <NotiForAdmin>{notiTotalCancel}</NotiForAdmin>}
                                                                              </CustomBadge>
                                                                           </div>
                                                                        </Nav.Item>
                                                                     )
                                                                  )
                                                         })}
                                                   </MenuScroll>
                                                </MenuSecondLevel>
                                             </>
                                          ) || (
                                                <></>
                                             )} */}
                                          {menuFirsts[menuFirstKey] && mSub.length && (
                                             <>
                                                <MenuSecondLevel
                                                   className={`menu-second ${toggleLevel2 === menuFirstId ? 'active' : ''} ${menuFirstId === 12 ? 'active12' : menuFirstId === 13 ? 'active13' : ''}`}
                                                >
                                                   <MenuScroll className={'menu-second-wrap'}>
                                                      {menuFirsts[menuFirstKey] &&
                                                         mSub &&
                                                         _.map(mSub.sort((a: any, b: any) => a?.menuSecondSorting - b?.menuSecondSorting), ({ menuSecondId, menuSecondKey, menuSecoundTags, menuThirds: mThirds }: any, iMSub: number) => {
                                                            if (menuSeconds[menuSecondKey])
                                                               return (menuSeconds[menuSecondKey] && mThirds.length) && (
                                                                  <Nav.Item key={`menu-second-${menuSecondId}`} id={menuSecondId} className={`menu-second-level ${menuSeconds[menuSecondKey].isHidden ? 'd-none' : ''}`}>
                                                                     <Button
                                                                        className={`item-second-list text-ellipsis w-100`}
                                                                        onClick={(e) => {
                                                                           e.stopPropagation(); // Stop event propagation
                                                                           onToggle(`menu-second-${menuSecondId}`);
                                                                        }}
                                                                        aria-controls={`menu-second-${menuSecondId}`}
                                                                        aria-expanded={toggleLevel3[`menu-second-${menuSecondId}`]}
                                                                        endIcon={toggleLevel3[`menu-second-${menuSecondId}`] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}>
                                                                        <TextEllipsis title={t(menuSeconds[menuSecondKey].textName)} ellipsis={menuSecondKey === 'MANAGE_DOCTOR_FEE' || menuSecondKey === 'DEFAULT_PRODUCT'} />
                                                                     </Button>
                                                                     <Collapse in={toggleLevel3[`menu-second-${menuSecondId}`]}>
                                                                        <MenuThirdLevel id={`menu-second-${menuSecondId}`} className="menu-third">
                                                                           <ul className={'menu-third-level'}>
                                                                              {_.map(mThirds, ({ menuThirdId, menuThirdKey, menuThirdTags }: any, iMThirds: number) => {
                                                                                 if (menuThirds[menuThirdKey])
                                                                                    return (
                                                                                       menuThirds[menuThirdKey] && (
                                                                                          <Nav.Item key={`menu-third-${menuThirdId}`} className={`item-third-list ${menuThirdKey === 'CURRENCY' && 'd-none'}`}>
                                                                                             <li
                                                                                                className={'w-100 text-ellipsis'}
                                                                                                onClick={(e) => {
                                                                                                   e.stopPropagation(); // Prevent event bubbling
                                                                                                   goToRoute(menuThirds[menuThirdKey].path, mThirds[iMThirds]);
                                                                                                }}
                                                                                             >
                                                                                                <TextEllipsis
                                                                                                   title={t(menuThirds[`${menuThirdKey}`].textName)} />
                                                                                             </li>
                                                                                          </Nav.Item>
                                                                                       )
                                                                                    )
                                                                              })}
                                                                           </ul>
                                                                        </MenuThirdLevel>
                                                                     </Collapse>
                                                                  </Nav.Item>
                                                               ) || (
                                                                     menuSeconds[menuSecondKey] && (
                                                                        <Nav.Item key={`menu-second-${menuSecondId}`} className={`menu-second-level ${menuSeconds[menuSecondKey].isHidden ? 'd-none' : ''}`}>
                                                                           <div
                                                                              className={'item-second-list text-ellipsis'}
                                                                              onClick={(e) => {
                                                                                 e.stopPropagation(); // Stop event propagation
                                                                                 goToRoute(menuSeconds[menuSecondKey].path, mSub[iMSub]);
                                                                              }}
                                                                           >
                                                                              <CustomBadge
                                                                                 badgeContent={10}
                                                                                 max={10}
                                                                                 color="error"
                                                                                 className="menu-badge w-100"
                                                                                 invisible={!menuSeconds[menuSecondKey].badge}
                                                                                 sx={{ '.MuiBadge-badge:not(.MuiBadge-invisible)': { position: 'relative', top: 5, left: 8, right: 0, bottom: 0, transform: 'none' } }}>
                                                                                 <TextEllipsis title={t(menuSeconds[menuSecondKey].textName)} />
                                                                                 {!isTenant && menuFirstId === 11 && notiTotalCancel > 0 && <NotiForAdmin>{notiTotalCancel}</NotiForAdmin>}
                                                                                 {/* ตำแหน่ง default ของ NotiForAdmin ออกแบบไว้ทับไอคอนเมนูชั้นแรก — ชั้นนี้ไม่มีไอคอน จะไปทับตัวหนังสือ จึงชิดขวาของแถวแทน */}
                                                                                 {!isTenant && menuSecondKey === menuSeconds.CUSTOMER_MANAGEMENT.key && customerHeirCount > 0 && (
                                                                                    <NotiForAdmin style={{ left: 'auto', right: 0, bottom: 'auto', top: '50%', transform: 'translateY(-50%)', width: 24, height: 24 }}>
                                                                                       {customerHeirCount}
                                                                                    </NotiForAdmin>
                                                                                 )}
                                                                              </CustomBadge>
                                                                           </div>
                                                                        </Nav.Item>
                                                                     )
                                                                  )
                                                         })}
                                                   </MenuScroll>
                                                </MenuSecondLevel>
                                             </>
                                          ) || (
                                                <></>
                                             )}
                                       </Nav.Item>
                                    </>
                                 ) || (
                                    menuFirsts[menuFirstKey] &&
                                    !menuFirsts[menuFirstKey].disabled && (
                                       <Nav.Item
                                          key={`menu-first-${menuFirstId}`}
                                          className={`d-flex flex-row menu-first-level`}
                                          onClick={() => goToRoute(menuFirsts[menuFirstKey].path, menus[iMFrist])}
                                       // onMouseEnter={() => isToggleLevel1(Number(0))}
                                       >
                                          <div className={'flex-name'}>
                                             <CustomBadge badgeContent={1} max={10} color="error" className="menu-badge" invisible={!menuFirsts[menuFirstKey].badge}>
                                                <IconButton color="primary" component="span" className={`menu-first-icon p-0 ${activeMenuLevel1 === menuFirstKey ? 'active active-level-1' : ''}`}>
                                                   {menuFirsts[menuFirstKey].icon}
                                                </IconButton>
                                                {!isTenant && menuFirstId === 4 && notiTotalInvoice > 0 && <NotiForAdmin>{notiTotalInvoice}</NotiForAdmin>}
                                                {!isTenant && menuFirstId === 6 && notiTotalRepair > 0 && <NotiForAdmin>{notiTotalRepair}</NotiForAdmin>}
                                                {!isTenant && menuFirstId === 7 && notiTotalTransfer > 0 && <NotiForAdmin>{notiTotalTransfer}</NotiForAdmin>}
                                                {!isTenant && menuFirstId === 8 && notiTotalCertificate > 0 && <NotiForAdmin>{notiTotalCertificate}</NotiForAdmin>}
                                                {!isTenant && menuFirstId === 11 && notiTotalCancel > 0 && <NotiForAdmin>{notiTotalCancel}</NotiForAdmin>}
                                             </CustomBadge>
                                             <div className="menu-first-text text-ellipsis">
                                                <TextEllipsis title={t(menuFirsts[menuFirstKey].textName)} />
                                             </div>
                                          </div>
                                       </Nav.Item>
                                    )
                                 )
                              )}
                           </>
                        )
                  })
               )}
            </MenuFirstLevelScroll>
         </MenuFirstLevel>
         {toggleLevel2 > 0 && <SidebarBackdrop className={`sidebar-backdrop-desktop ${toggleLevel2 > 0 ? 'show' : ''}`} onClick={hideSidebar}></SidebarBackdrop>}
      </>
   )
}
